import Guard from '@/services/middleware'
import Debug from './Debug'
import ChangeLog from './ChangeLog'
import TermsOfUse from './TermsOfUse'

const DashLayout = () => import('@/layouts/DashLayout.vue')
const Home = () => import('@/views/controller/ControllerHome.vue')

export default [
    {
        path: '/controller',
        component: DashLayout,
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkPermission,
            Guard.checkController,
        ],
        children: [
            { path: '', name: 'controller.home', component: Home, meta: { title: 'Controller', permission: 19 } },
            ...Debug,
            ...ChangeLog,
            ...TermsOfUse,
        ],
    },
]
